<template>
  <div class="modal-card" style="margin: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("vending.addCategory") }}
      </p>
    </header>

    <section class="modal-card-body">
      <b-field style="margin-top: 1rem; margin-bottom: 1rem;">
        <b-field>
          <b-select :placeholder="$t('common.select')" v-model="category">
            <option value="">
              {{ $t("common.select") }}
            </option>

            <option v-for="c in categoriesToAdd" :value="c" :key="c._id">
              {{ c.name }}
            </option>
          </b-select>

          <b-button
            class="button"
            :style="{
              backgroundColor: $primaryColor,
              color: $primaryColorContrast
            }"
            @click="addVendingCategory(category)"
            :disabled="!category"
          >
            {{ $t("common.add") }}
          </b-button>
        </b-field>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  props: ["vending"],

  mixins: [common],

  data() {
    return {
      isLoading: false,
      category: ""
    };
  },

  methods: {
    getVendingCategoriesToAdd() {
      this.isLoading = true;
      this.$store
        .dispatch("getVendingCategories")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    addVendingCategory(category) {
      this.isLoading = true;
      this.$store
        .dispatch("addVendingCategory", {
          category: category,
          vendingId: this.vending._id
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else if (res.data.result === "ok") {
            this.$buefy.toast.open({
              message: this.$t("vending.categoryAdded"),
              type: "is-success",
              position: "is-bottom",
              duration: 3000
            });
            this.$emit("update-vending");
            this.$parent.close();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["vendingCategories"]),

    categoriesToAdd() {
      const catalogCategories = [];
      for (let i = 0; i < this.vending.catalog.length; i++) {
        catalogCategories.push(this.vending.catalog[i]._id);
      }

      return this.vendingCategories.filter(c => {
        return !catalogCategories.includes(c._id.toString());
      });
    }
  },

  mounted() {
    this.getVendingCategoriesToAdd();
  }
};
</script>
